import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { CampaignDebugView } from '../../containers/campaigns/CampaignDebugView';

export const AdminCampaignDebugPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<CampaignDebugView />
		</AdminDashboardPageLayout>
	);
};
